import React from 'react';
import { DEFAULT_PDF_IMG } from '../../utils/contants';

export const SafeImagePreview = ({ article, className, disableRedirect }) => {
	if (!article) {
		return null;
	}

	let imageSrc = article.img_url;

	if (imageSrc && imageSrc.includes('.pdf')) {
		imageSrc = DEFAULT_PDF_IMG;
	}

	if (disableRedirect) {
		return (
			<div className={className}>
				<img src={imageSrc} />
			</div>
		);
	}

	return (
		<a className={className} href={article.img_url} target="_blank">
			<img src={imageSrc} />
		</a>
	);
};
